// Унифицированная нормализация ошибок RTK Query/GraphQL в строку для отображения в UI
// Старайтесь использовать её в хуках/компонентах, чтобы получить человеческое сообщение.

export function normalizeRtkqError(error: any): string {
  if (!error) return '';

  // RTK Query error shape: { status, data, error, message }
  const status = (error as any).status;
  const data = (error as any).data;
  const msg = (error as any).message ?? (error as any).error;

  if (typeof data === 'string') return data;

  // GraphQL errors array
  if (Array.isArray(data) && data.length && typeof data[0]?.message === 'string') {
    return data[0].message;
  }

  // Axios-like error data
  if (data && typeof data === 'object') {
    if (typeof (data as any).message === 'string') return (data as any).message;
    if (Array.isArray((data as any).errors) && (data as any).errors[0]?.message) return (data as any).errors[0].message;
  }

  if (typeof msg === 'string') return msg;

  if (status) return `Request failed (status ${status})`;

  try {
    return JSON.stringify(error);
  } catch (_e) {
    return String(error);
  }
}

export default normalizeRtkqError;
